import { QuantifyAnomaliesTableViewGrid } from '@modules/quantify/components/QuantifyAnomaliesTableView/QuantifyAnomaliesTableViewGrid';
import { getAnomalousTimestampFromDataPoints } from '@modules/quantify/components/QuantifyAnomaliesTableView/helpers';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Box, Stack, Typography } from '@mui/material';
import { useMeasure } from 'react-use';

interface QuantifyAnomaliesTableViewProps {
  shouldShowAddToFilter?: boolean;
}

export const QuantifyAnomaliesTableView = ({
  shouldShowAddToFilter = true,
}: QuantifyAnomaliesTableViewProps) => {
  const tableRows = useQuantifyStore(
    ({ reportData }) => reportData.quantify.tableRows,
  );

  const [listContainerRef, { height: listContainerHeight }] = useMeasure();

  const anomalousTimestamp = tableRows
    ? getAnomalousTimestampFromDataPoints(tableRows)
    : null;

  if (!anomalousTimestamp) {
    return (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        height="100%"
      >
        <Typography variant="body1" color="text.secondary">
          No Anomalies found.
        </Typography>
      </Stack>
    );
  }

  return (
    <Box height="100%" ref={listContainerRef}>
      <QuantifyAnomaliesTableViewGrid
        anomalousTimestamp={anomalousTimestamp}
        shouldShowAddToFilter={shouldShowAddToFilter}
        containerHeight={listContainerHeight}
      />
    </Box>
  );
};
